<template>
    <div class="page_number_wrap">
        <div class="col-md-12">
            <div class="page_number" style="border:0">
                <ul>
                    <a @click="prev()"><li><div class="icon-long-arrow-left"></div></li></a>
                    <span v-if="true">...</span>
                    <a v-for="(where, idx) of interval" :key="idx" @click="goPage(where)"><li class="{'page_number_target': where === now}">{{where}}</li></a>
                    <span>...</span>
                    <a @click="next()"><li><div class="icon-long-arrow-right"></div></li></a>
                </ul>
            </div>
        </div>
    </div>
</template>

<script>
import axios from 'axios'
import {API_URL, userStatus} from './config.js'
import user from './user.js'

const showPages = 5

export default {
  name: 'Pagination',
  props: ["items"],
  data () {
    return {
      now: 1,
      showPages: showPages,
      total: items.TotalPage,
      page: items.Page
    }
  },
  methods: {
    ...user,
    goPage (page) {
        this.now = page
    },
    prev () {
        if(now > 0) now--
    },
    next () {
        if(now < Math.ceil(pages)) now++
    }
  },
  computed: {
    pages () {
        return total/page
    },
    interval () {
        // page 是一頁有幾個
        // showPages 是顯示幾個數字
        // 邏輯是，當點到最後一個數字，才會計算下一輪的 pagination 的數字
        // total,page,now,
        let itemPerPage = total/page
        let remain = total%page
        if (itemPerPage < 1) {
            return 1
        } else {
            // now
        }
        return 

    }
  },
  mounted () {
    // console.log(`${this.name} mounted`)
    // if (this.item) $('[data-remodal-id=modal-'+this.item.BookID+']').remodal()
    // $('[data-remodal-id=modal-'+this.item.BookID+']').remodal()
  }
}
</script>


// WEBPACK FOOTER //
// src/Pagination.vue